var _path, _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBhim(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 73,
    viewBox: "0 0 70 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.00000316908,
    y: 72.5,
    width: 72.5,
    height: 70,
    rx: 20,
    transform: "rotate(-90 3.16908e-06 72.5)",
    fill: "white",
    fillOpacity: 0.2,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.500003,
    y: 72,
    width: 71.5,
    height: 69,
    rx: 19.5,
    transform: "rotate(-90 0.500003 72)",
    stroke: "white",
    strokeOpacity: 0.5,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3077 39.4283L34.1242 47.0984L23.9731 36.3595C22.643 34.9522 23.6141 32.6196 25.548 32.5796L56.4852 31.9186C58.2438 31.8836 59.3428 33.818 58.4147 35.3267L42.2173 61.715C41.2033 63.3662 38.7281 63.036 38.1906 61.175L34.1242 47.0984",
    fill: "url(#paint0_linear_8614_3069)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_8614_3069)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.1882 41.3798L37.3261 45.954L31.2723 39.5497C30.4791 38.7104 31.0582 37.3194 32.2115 37.2955L50.6613 36.9013C51.7101 36.8804 52.3655 38.0341 51.812 38.9338L42.1525 54.6708C41.5478 55.6555 40.0716 55.4586 39.7511 54.3488L37.3261 45.954",
    fill: "#61DE70"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: -3.08904,
    y: 11.2396,
    width: 68.475,
    height: 62.891
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(5.96px)",
      clipPath: "url(#bgblur_0_8614_3069_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 11.9255
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-outside-1_8614_3069",
    maskUnits: "userSpaceOnUse",
    x: 6.99429,
    y: 5.64239,
    width: 57.3733,
    height: 58.5021,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 6.99429,
    y: 5.64239,
    width: 57.3733,
    height: 58.5021
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8556 32.9196L22.604 42.3748L10.0904 29.1366C8.45079 27.4017 9.64782 24.5263 12.0318 24.477L50.1689 23.6622C52.3368 23.619 53.6916 26.0037 52.5475 27.8635L32.5806 60.393C31.3305 62.4285 28.2793 62.0214 27.6167 59.7273L22.604 42.3748"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8556 32.9196L22.604 42.3748L10.0904 29.1366C8.45079 27.4017 9.64782 24.5263 12.0318 24.477L50.1689 23.6622C52.3368 23.619 53.6916 26.0037 52.5475 27.8635L32.5806 60.393C31.3305 62.4285 28.2793 62.0214 27.6167 59.7273L22.604 42.3748",
    fill: "#61DE70",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1055 33.3491C39.3427 33.2111 39.4231 32.9069 39.2851 32.6697C39.1471 32.4325 38.8429 32.3521 38.6057 32.4901L38.8556 32.9196L39.1055 33.3491ZM10.0904 29.1366L9.7293 29.4779L9.72933 29.478L10.0904 29.1366ZM12.0318 24.477L12.0421 24.9738L12.0425 24.9738L12.0318 24.477ZM50.1689 23.6622L50.159 23.1654L50.1583 23.1654L50.1689 23.6622ZM52.5475 27.8635L52.1243 27.6032L52.1241 27.6036L52.5475 27.8635ZM32.5806 60.393L33.004 60.653L33.004 60.653L32.5806 60.393ZM27.6167 59.7273L28.0941 59.5895L28.0941 59.5894L27.6167 59.7273ZM38.8556 32.9196L38.6057 32.4901L22.3541 41.9453L22.604 42.3748L22.8538 42.8043L39.1055 33.3491L38.8556 32.9196ZM22.604 42.3748L22.9651 42.0335L10.4515 28.7953L10.0904 29.1366L9.72933 29.478L22.2429 42.7161L22.604 42.3748ZM10.0904 29.1366L10.4516 28.7953C9.10597 27.3716 10.092 25.0141 12.0421 24.9738L12.0318 24.477L12.0216 23.9802C9.20361 24.0385 7.79561 27.4319 9.7293 29.4779L10.0904 29.1366ZM12.0318 24.477L12.0425 24.9738L50.1795 24.159L50.1689 23.6622L50.1583 23.1654L12.0212 23.9802L12.0318 24.477ZM50.1689 23.6622L50.1788 24.159C51.9483 24.1238 53.0652 26.0736 52.1243 27.6032L52.5475 27.8635L52.9708 28.1239C54.318 25.9338 52.7254 23.1143 50.159 23.1654L50.1689 23.6622ZM52.5475 27.8635L52.1241 27.6036L32.1571 60.1331L32.5806 60.393L33.004 60.653L52.971 28.1234L52.5475 27.8635ZM32.5806 60.393L32.1571 60.133C31.1315 61.8031 28.6361 61.4662 28.0941 59.5895L27.6167 59.7273L27.1393 59.8652C27.9225 62.5767 31.5295 63.0539 33.004 60.653L32.5806 60.393ZM27.6167 59.7273L28.0941 59.5894L23.0813 42.2369L22.604 42.3748L22.1266 42.5127L27.1393 59.8652L27.6167 59.7273Z",
    fill: "url(#paint1_linear_8614_3069)",
    mask: "url(#path-5-outside-1_8614_3069)"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 19.1154,
    y: 24.6989,
    width: 27.7193,
    height: 23.3541
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(3.73px)",
      clipPath: "url(#bgblur_1_8614_3069_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_8614_3069)",
    "data-figma-bg-blur-radius": 7.45342
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7354 39.9784C26.3923 39.3843 26.5959 38.6245 27.19 38.2815L37.5178 32.3188C38.112 31.9757 38.8717 32.1793 39.2147 32.7735C39.5578 33.3676 39.3542 34.1274 38.76 34.4704L28.4323 40.4331C27.8381 40.7762 27.0784 40.5726 26.7354 39.9784Z",
    fill: "url(#paint2_linear_8614_3069)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8217 39.9289C26.5062 39.3823 26.6932 38.6836 27.2397 38.368L37.5678 32.4046C38.1144 32.0893 38.8137 32.2769 39.1292 32.8234C39.4445 33.3699 39.2569 34.0693 38.7104 34.3848L28.3826 40.3468C27.8361 40.6624 27.1374 40.4753 26.8217 39.9289Z",
    stroke: "url(#paint3_linear_8614_3069)",
    strokeWidth: 0.198758
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8614_3069",
    x: 23.9497,
    y: 29.9448,
    width: 35.02,
    height: 32.3193,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.47826,
    result: "effect1_foregroundBlur_8614_3069"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_8614_3069_clip_path",
    transform: "translate(3.08904 -11.2396)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8556 32.9196L22.604 42.3748L10.0904 29.1366C8.45079 27.4017 9.64782 24.5263 12.0318 24.477L50.1689 23.6622C52.3368 23.619 53.6916 26.0037 52.5475 27.8635L32.5806 60.393C31.3305 62.4285 28.2793 62.0214 27.6167 59.7273L22.604 42.3748"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_8614_3069",
    x: 19.1154,
    y: 24.6989,
    width: 27.7193,
    height: 23.3541,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.48447,
    dy: 2.48447
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.48447
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.380392 0 0 0 0 0.870588 0 0 0 0 0.439216 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8614_3069"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8614_3069",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_8614_3069_clip_path",
    transform: "translate(-19.1154 -24.6989)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7354 39.9784C26.3923 39.3843 26.5959 38.6245 27.19 38.2815L37.5178 32.3188C38.112 31.9757 38.8717 32.1793 39.2147 32.7735C39.5578 33.3676 39.3542 34.1274 38.76 34.4704L28.4323 40.4331C27.8381 40.7762 27.0784 40.5726 26.7354 39.9784Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8614_3069",
    x1: 42.7555,
    y1: 28.1464,
    x2: 33.9138,
    y2: 61.1439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61DE70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8FFB2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8614_3069",
    x1: 29.7387,
    y1: 54.7107,
    x2: 46.0461,
    y2: 17.3155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8614_3069",
    x1: 37.9332,
    y1: 32.597,
    x2: 25.9649,
    y2: 42.8945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8614_3069",
    x1: 28.6016,
    y1: 39.866,
    x2: 27.4075,
    y2: 35.9832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBhim);
export default __webpack_public_path__ + "static/media/bhim.b0de853292f4617121fbb37449a8093b.svg";
export { ForwardRef as ReactComponent };